import { Box, Button, Checkbox, Modal, Text } from '@fozito/common-ui';
import { Card, ModalProps } from 'antd';
import { first, get, union } from 'lodash';
import { FooterActions } from 'modules/POS/Cashier/components/styles';
import cashierService from 'modules/POS/services';
import cashierApis from 'modules/POS/services/apis';
import { IApiMergeBillBody } from 'modules/POS/services/types/bill';
import { IBillOnHoldItem } from 'modules/POS/services/types/ticket';
import { useMemo, useState } from 'react';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
const styles: ModalProps['styles'] = {
  header: { display: 'none' },
  body: {
    position: 'relative',
    maxHeight: 'unset',
    height: '75vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'unset',
  },
  content: { overflow: 'unset', maxHeight: 'unset' },
};
type Props = {
  open: boolean;
  onClose: () => void;
  onComplete: (billId: string) => void;
};
const ModalOnHoldTickets = ({ onClose, open, onComplete }: Props) => {
  const data = cashierService.selectors.lstBillOnHold();
  const [selections, setSelections] = useState<string>('');
  const dispatch = useAppDispatch();

  const onClickItem = (item: IBillOnHoldItem) => () => {
    if (selections.includes(item.billId)) {
      setSelections(selections.replace(item.billId, ''));
    } else {
      setSelections(selections.concat(',' + item.billId));
    }
  };

  const selectedLists = useMemo(() => union(selections.split(',').filter(Boolean)), [selections]);

  const onDone = async () => {
    const billIds = union(selections.split(',').filter(Boolean));
    const currentBillId = first(billIds) || '';
    if (!currentBillId) return;
    const body: IApiMergeBillBody = {
      currentBillId,
      lstBillMerge: billIds.filter(o => o !== currentBillId),
    };
    setSelections('');
    setPageLoading(true);
    try {
      const res: IResponseData<{ billId: string }> = await cashierApis.mergeTicket(body);
      if (res.data.data.billId) {
        toast.success('Success');
        dispatch(cashierService.actions.async.lstBillOnHold.fetch());
        onComplete(res.data.data.billId);
        onClose();
      }
    } catch (error) {
      const msg = get(error, 'response.data.message');
      toast.error(msg ?? 'Fail!');
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <Modal title='ON HOLD TICKETS' open={open} onClose={onClose} onCancel={onClose} width={'70vw'} styles={styles}>
      <Box className="ant-modal-header" position='relative' display='flex' alignItems='center'>
        <div className="ant-modal-title" id=":rl:">
          <Text title_h5_24_semibold_caplock color_text_1>Merge Tickets</Text>
        </div>
      </Box>
      <Container>
        <Box position='absolute' inset={0} overflow='auto'>
          <StyledOrders>
            {data.map((item) => {
              const selectedDelete = selections.includes(item.billId);
              return (
                <ContainerCard onClick={onClickItem(item)} className="order-card" key={item.billId} styles={{ body: { padding: 0, display: 'flex', flexDirection: 'column' } }}>
                  <div className="order-header">
                    <span className="order-number">#{item.ticketNumber}</span>
                    <span className="order-time" style={{ flex: 1 }}>{item.createdDate}</span>
                    <Checkbox value={selectedDelete} />
                  </div>
                  <div className="order-details">{item.customerName || 'Unknown Customer'}</div>
                  <div className="order-items">{item.customerPhone ? formatPhone(item.customerPhone) : '--'}</div>
                  <div className="order-items">{''}</div>
                  <div className="order-price">{formatCurrency(item.total || 0)}</div>
                </ContainerCard>
              );
            })}
          </StyledOrders>
        </Box>
      </Container>
      <FooterActions style={{ position: 'sticky', bottom: 0, zIndex: 2, background: '#fff' }}>
        <Button style={{ flex: 1 }} onClick={onClose} type_cancel>Close</Button>
        <Button disabled={!selectedLists.length || selectedLists.length === 1} style={{ flex: 1 }} onClick={onDone} type_primary>Ok</Button>
      </FooterActions>
    </Modal>
  );
};

export default ModalOnHoldTickets;
const Container = styled.div`
  flex: 1;
  position: relative;
`;

const ContainerCard = styled(Card)`
  &.order-card:hover {
    cursor: pointer;
    background: #eee;
  }
`;
const StyledOrders = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 8px;
  padding: 16px;

  .order-card {
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    text-align: left;
  }
  .order-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .order-number {
    background: #2c3e50;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-weight: bold;
  }
  .order-time {
    font-size: 12px;
    color: #666;
  }
  .order-details {
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
  }
  .order-items {
    font-size: 14px;
    color: #666;
  }
  .order-price {
    font-size: 16px;
    font-weight: bold;
  }
  .checkout-button {
    width: 100%;
    background: #ff6b6b;
    color: white;
    border: none;
    margin-top: 10px;
  }
`;